/**
 * Ajuda - Botão "?" com explicação contextual do campo
 *
 * Substitui os parágrafos longos do painel de configuração por um ícone
 * discreto ao lado do rótulo, liberando espaço sem perder a explicação.
 * Camada de apresentação apenas.
 *
 * @version 1.0.0
 * RELEASE: 2026-08-31 v1.0.0 - Extraído do WorkflowInspector para reuso nos
 *          formulários do inspetor (saídas, ações, gatilho).
 */

import { HelpCircle } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export function Ajuda({ texto }: { texto: string }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Ajuda sobre este campo"
          className="text-muted-foreground transition-colors hover:text-foreground"
        >
          <HelpCircle className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 text-xs leading-relaxed">
        {texto}
      </PopoverContent>
    </Popover>
  );
}
